import React, { useState, useEffect } from 'react';
import { TextField, Box, Grid, Button, Typography, CircularProgress } from '@mui/material';
import ValidationFunctions from '../../utils/ValidationFunctions';
import { useDispatch, useSelector } from 'react-redux';
import * as registerActions from '../../core/Store/Actions/RegisterActions';
import Loader from '../../components/loader';
import { Link, useNavigate } from 'react-router-dom';
import { formatPhoneNumber } from '../../components/formatPhone';
import * as patientActions from '../../core/Store/Actions/PatientActions';
import './styles.css';
//import { formatPhoneNumber } from '../utils/globalFunctions';
const SignInScreen = () => {
    const loading = useSelector(state => state.registerReducer.loading);
    const validData = useSelector(state => state.registerReducer.validData);
    const patientCheck = useSelector(state => state.registerReducer.patientData);
    const [username, setUsername] = useState('');
    const [validEmail, setValidEmail] = useState(false);
    const [validMobile, setValidMobile] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('authtoken');
        localStorage.removeItem('registertoken');
        dispatch(registerActions.resetRegisterData());
        dispatch(patientActions.resetPatientData());
    }, []);

    const onTextChange = (text) => {
        const textValue = text.target.value;
        if (textValue) {
            username && isNaN(
                username
                    .trim()
                    .replace('(', '')
                    .replace(')', '')
                    .replace('-', '')
                    .replace(' ', ''),
            ) ? setUsername(textValue) : formatPhoneNumber(textValue, setUsername);
        }
        else {
            setUsername(textValue);
            setValidEmail(false);
            setValidMobile(false);
        }
    }
    const onSubmit = () => {
        if (
            username.trim().length === 0 ||
            isNaN(
                username
                    .trim()
                    .replace('(', '')
                    .replace(')', '')
                    .replace('-', '')
                    .replace(' ', ''),
            )
        ) {
            setValidMobile(false);
            let errorOnEmail = ValidationFunctions.checkIsEmailValid(username.trim());
            if (errorOnEmail) {
                setValidEmail(true);
                return;
            }
        } else {
            setValidEmail(false);
            let isMobileValid = ValidationFunctions.checkIsMobileValid(username);
            if (isMobileValid && (username.length > 10 || username.length < 10)) {
                setValidMobile(true);
                return;
            }
        }
        setValidEmail(false);
        setValidMobile(false);
        const type = username && isNaN(
            username
                .trim()
                .replace('(', '')
                .replace(')', '')
                .replace('-', '')
                .replace(' ', ''),
        ) ? 'email' : 'phone';
        // const payload = {
        //     alias: "medical",
        //     ip_address: null,
        //     verifyType: type,
        //     verifyValue: username
        // }
        const payload = {
            username: username
        }
        dispatch(registerActions.validateUserRequest(payload));
        // const payload2 = {
        //     emailphone: username,
        //     employerId: ""
        // }
        //dispatch(registerActions.checkPatientExistsRequest(payload2));
    }
    // useEffect(() => {
    //     // if (patientCheck) {
    //     console.log("Patient Check", patientCheck);
    //     //}
    // }, [patientCheck]);
    useEffect(() => {
        if (validData && validData.doc_id) {
            localStorage.setItem('authtoken', validData.doc_id);
            navigate('/room/verify');
            dispatch(registerActions.validateUserResponse({}));
        }
    }, [validData]);

    const ButtonComponent = (props) => {
        const { onClick, loading, title, style } = props;
        return (
            <Button style={style} variant="contained" onClick={onClick} disabled={loading}>
                {loading && <CircularProgress style={{ color: '#ffffff' }} size={20} />}
                {!loading && `${title}`}
            </Button>
        );
    }
    return (
        <Grid>
            <Grid className="mainSignDiv">
                <Grid>
                    <Box style={{
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}>
                        <Typography style={{
                            fontSize: '28px', fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '600',
                            marginBottom: '5%'
                        }}>Tell Us About Yourself</Typography>
                        <Typography style={{
                            fontSize: '18px',
                            fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            marginBottom: '1%', color: '#565656'
                        }}>Enter your phone number or email address to begin the check-in process.</Typography>
                        <Typography style={{
                            fontSize: '18px',
                            fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            marginBottom: '5%', color: '#565656'
                        }}>If you are a existing user, please use our app to login.</Typography>
                    </Box>
                    <Grid style={{
                        marginBottom: 20,
                        alignSelf: 'center'
                    }}>
                        <TextField style={{
                            width: '100%',
                            //height: '79px',
                            backgroundColor: ' #F2F2F2',
                            borderRadius: '5px',
                            fontFamily: 'manrope',
                            fontStyle: 'normal',
                        }}
                            onChange={(text) => {
                                onTextChange(text)
                            }}
                            value={username}
                            placeholder={'Phone number/ Email'}
                            disabled={loading}
                        />
                        {validEmail && <Typography style={{
                            fontSize: '18px',
                            fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '400', color: 'red',
                        }}>Please enter valid email address</Typography>}
                        {validMobile && <Typography style={{
                            fontSize: '18px',
                            fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '400', color: 'red'
                        }}>Please enter valid mobile number</Typography>}
                    </Grid>
                    <ButtonComponent loading={loading} title='Next' style={{ width: '100%', padding: '3%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', marginTop: '20%', borderRadius: '10px' }} onClick={onSubmit} />
                    {/* <Button style={{ width: '100%', padding: '3%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', marginTop: 70 }} disabled={!username || loading} variant="contained" onClick={onSubmit} >Next</Button> */}
                    {/* <Typography>{username}</Typography> */}
                </Grid>
            </Grid>
            {/* {loading && <Loader />} */}
        </Grid>
    );
}
export default SignInScreen;